import { constants } from "@newsela/angelou";

const { colors } = constants;
const neutral400 = colors.ui.neutral[400];
const neutral600 = colors.ui.neutral[600];

export const textAreaCss = {
  root: {
    width: "100%",
  },
  label: {
    color: neutral600,
  },
  text: {
    color: neutral600,

    "&::placeholder": {
      color: neutral400,
    },
  },
};

export const actionButtonGroupCss = {
  display: "flex",
  gap: "8px",
  justifyContent: "flex-end",
  marginTop: "8px",
};

export const buttonCss = {
  flexGrow: "1",
  justifyContent: "center",
  padding: "8px",
};
